/**
 * updreq Module
 *
 */

function _get_edit_me_h_hash() {
  if (/\/r\/edit_me_h\/([\w-]+)$/.test(window.location.href)) {
    return RegExp.$1
  } else {
    return null
  }
}

angular
  .module('updreqs', ['ngResource', 'settings', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.updreqs.get_edit_links(), {
        controller: 'UpdreqGetEditLinksCtrl',
        templateUrl: '/r/static/templates/updreqs/get_edit_links.html',
      })
      .when(CONFIG.url.updreqs.all(), {controller: 'UpdreqCtrl', templateUrl: '/r/static/templates/updreqs/list.html'})
      .when(CONFIG.url.updreqs.create(), {
        controller: 'UpdreqAddCtrl',
        templateUrl: '/r/static/templates/updreqs/new.html',
      })
      .when(CONFIG.url.updreqs.view(), {
        controller: 'UpdreqEditCtrl',
        templateUrl: '/r/static/templates/updreqs/single.html',
      })
      .when(CONFIG.url.updreqs.edit_me_h(), {
        controller: 'UpdreqEditMeCtrl',
        templateUrl: '/r/static/templates/updreqs/edit_me.html',
      })
      .when(CONFIG.url.updreqs.edit_me_s(), {
        controller: 'UpdreqEditMeCtrl',
        templateUrl: '/r/static/templates/updreqs/edit_me.html',
      })
  }])

  .factory('Updreq', ['$resource', function ($resource) {
    var urlParams = new URLSearchParams(window.location.search)
    var Updreq = $resource(
      CONFIG.api('updreqs'),
      {},
      {
        query: {method: 'GET', isArray: false},
        edit_me_s: {method: 'POST', isArray: false, params: {id: 'edit_me_s', edit_for: urlParams.get('edit_for')}},
        edit_me_h: {method: 'POST', isArray: false, params: {id: 'edit_me_h'}},
        update_me_s: {method: 'POST', params: {id: 'update_me_s'}},
        update_me_h: {method: 'POST', params: {id: 'update_me_h'}},
        supersearch: {method: 'POST', isArray: false, params: {id: 'supersearch'}},
        preview: {method: 'POST', params: {id: 'preview'}},
        send_edit_links: {method: 'POST', params: {id: 'send_edit_links'}},
      },
    )
    return Updreq
  }])

/* Controllers */

angular.module('updreqs').controller('UpdreqCtrl', ['$scope', '$location', '$timeout', '$rootScope', 'Updreq', function ($scope, $location, $timeout, $rootScope, Updreq) {
  if ($location.path() == CONFIG.url.updreqs.all()) {
    $scope.utils.setPageTitle(_('updreq_sent_updreqs'))
    $scope.utils.setPageID('members')
  }

  getUpdreqs()

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  function getUpdreqs() {
    Updreq.query(
      {
        id: 'all',
        dashboard: $location.path() !== CONFIG.url.updreqs.all(),
      },
      // success handler
      function (data) {
        $scope.updreqs = data.updreqs
        $scope.stats = data.stats

        $rootScope.updreqs_dashboard_ok = true

        // pagination
        $scope.pageSize = 20
        $scope.numberOfPages = Math.ceil($scope.updreqs.length / $scope.pageSize)
        $scope.currentPage = 0

        a4.loaded($scope)

        var refresh = false
        // $.each($scope.updreqs, function(i, a) {
        //   a.stats.sent_percentage = Math.floor(100 * (a.stats.total - a.stats.count_queued) / a.stats.total);
        //   if(a.stats.count_queued > 0) {
        //     refresh = true;
        //   }
        // });

        // if($location.path() == CONFIG.url.updreqs.all()) {
        //   $.each($scope.updreqs, function(val) {
        //     if ($scope.updreqs[val].stats.count_queued > 0) {
        //       a4.timeout($timeout, $scope, getUpdreqs, 5000);
        //       return false;
        //     }
        //   });
        // }
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }
}])

angular
  .module('updreqs')
  .controller('UpdreqAddCtrl', ['$rootScope', '$scope', '$location', 'Updreq', 'Settings', '$compile', function ($rootScope, $scope, $location, Updreq, Settings, $compile) {
    a4.checkStrongholdNotification($rootScope, $scope, $location, $compile)

    $scope.utils.setPageTitle(_('updreq_create_new_updreq'))
    $scope.utils.setPageID('members')

    $scope._sending = false
    $scope.previewing = false

    Settings.get({}, function (settings) {
      $scope.settings = settings
    })

    $scope.msg = new Updreq({
      subject: _('updreq_default_subject'),
      content: _('updreq_default_content'),
      msg_media: 'email',
    })
    a4.loaded($scope)

    $scope.proceed_to_payment = function () {
      var _self = this

      $scope.msg.filter = $scope.filter_to_post

      $scope._sending = true

      Updreq.save(
        {},
        $scope.msg,
        // success handler
        function (data) {
          _self.updreq_form.$dirty = false
          $location.path(CONFIG.url.mooney.method(data['mid'])).search('goto', CONFIG.get('urls.updreqs.all'))
          /*
        if(!$scope.msg.test_only) {
          $location.path(CONFIG.url.updreqs.all());
        } else {
          $scope._sending = false;
          // TODO, some sign here that the test was sent to the user?
        }*/
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }

    $scope.msgModel = function () {
      return 'updreq'
    }

    $scope.preview = a4.msgPreview($scope, Updreq)
    $scope.cancelPreview = a4.msgPreviewCancel($scope)

    // NB: This is found on announcements + invoices + updreqs
    $scope.$watch('settings+msg.msg_media', function () {
      if ($scope.settings) {
        $scope.emailMissing = $scope.msg.msg_media === 'email' && $scope.settings.email_missing_
        $scope.vatIdRequired = $scope.msg.msg_media === 'letter' && $scope.settings.vat_id_missing_
        $scope.bankAccountRequired = false
      }
    })
  }])

angular.module('updreqs').controller('UpdreqEditCtrl', ['$scope', '$routeParams', '$timeout', 'Updreq', function ($scope, $routeParams, $timeout, Updreq) {
  $scope.viewStatus = ''
  $scope.utils.setPageID('members')

  getUpdreq()

  function getUpdreq() {
    Updreq.get(
      {id: $routeParams.id},
      // success handler
      function (data) {
        $scope.msg = data
        $scope.msg.version = new Date($scope.msg.date_sent) > new Date('2021-06-02') ? 2 : 1
        a4.loaded($scope)

        // if(data.stats.count_queued > 0) {
        //   a4.timeout($timeout, $scope, getUpdreq, 5000);
        // }
      },
      a4.restErrorFactory($scope),
    )
  }

  // Near duplicate from invoices controller
  $scope.setViewStatus = function (viewStatus) {
    $scope.viewStatus = viewStatus
    if (!$scope.tableHeight) {
      $scope.tableHeight = $('table.mmp-payment-detail').height()
    }
    $('table.mmp-payment-detail').parent().css('height', $scope.tableHeight)
  }

  $scope.filterCombinedStatus = function (thing) {
    if ($scope.viewStatus === '') {
      return true
    } else {
      return thing.updreq_instance.status == $scope.viewStatus
    }
  }
}])

angular.module('updreqs').controller('UpdreqEditMeCtrl', ['$scope', '$location', 'Updreq', 'Settings', function ($scope, $location, Updreq, Settings) {
  var edit_me_api_func = function () {
    try {
      if (_get_edit_me_h_hash()) {
        return Updreq.edit_me_h
      } else if ($scope.session.user.id) {
        return Updreq.edit_me_s
      }
    } catch (e) {
      // session data not yet loaded
      return null
    }
  }

  var update_me_api_func = function () {
    if (_get_edit_me_h_hash()) {
      return Updreq.update_me_h
    } else {
      return Updreq.update_me_s
    }
  }

  // see updreq-thanks.html
  var thanks_goto = function () {
    if (_get_edit_me_h_hash()) {
      return '/r/page/updreq-thanks?src=h'
    } else {
      return '/r/page/updreq-thanks?src=s'
    }
  }

  var cancel_goto = function () {
    if (_get_edit_me_h_hash()) {
      return '/r/page/updreq-later'
    } else {
      if (D4GLOBALS.Grants.SiteAdmin) {
        return '/'
      } else {
        return '/@logout?GOTO=/r/page/updreq-later'
      }
    }
  }

  $scope.isAdmin = false
  $scope.utils.setPageID('members')
  $scope._sending = false
  $scope.passwordFieldsVisible = false
  $scope.passwordStrength = null

  // NB: Duplicated in member.js
  $scope.showPasswordFields = function () {
    $scope.passwordFieldsVisible = true
  }

  $scope.$watch(
    'member',
    function () {
      if ($scope.member) {
        $scope.member.active = $scope.member.active == 'false' || !$scope.member.active ? false : true

        if ($scope.passwordFieldsVisible && ($scope.member.newPassword_ || $scope.member.confirmNewPassword_)) {
          $scope.passwordStrength = a4.getPasswordStrength($scope.member.newPassword_)
        } else {
          $scope.passwordStrength = null
        }
      }
    },
    true,
  )

  $scope.$watch('session', function () {
    if (edit_me_api_func()) {
      edit_me_api_func()(
        {hash: _get_edit_me_h_hash()},
        // success
        function (results) {
          $scope.member = results.member
          $scope.fields = results.fields
          $scope.readonlyFields = $.grep(results.fields, function (e) {
            return e.type !== 'heading' && e.visibility === '1'
          }).length
          $scope.utils.setPageTitle($scope.fullname())

          // Do not show list of children with edit_me_h. Since there is no session, children must be edited via email links.
          if (_get_edit_me_h_hash()) {
            delete $scope.member.meta_.children
          }
          a4.loaded($scope)
        },
        // error
        function (error) {
          try {
            if (error.data.error.general) {
              alert(_(error.data.error.general[0]))
              location.href = '/r/updreqs/get_edit_links'
            }
          } catch (e) {
            console.warn(e)
            // some other error, no error.data.error.general[0]
            location.href = '/r/page/generic-error'
          }
        },
      )
    }
  })

  $scope.fullname = function () {
    if ($scope.member) {
      var first = $scope.member.firstname || ''
      var last = $scope.member.lastname || ''
      return [first, last].join(' ')
    }
  }

  $scope.editFor = function (id) {
    location.href = CONFIG.url.updreqs.edit_me_s() + '?' + jQuery.param({edit_for: id})
  }

  $scope.save = function () {
    $scope._sending = true
    a4.trimMemberFields($scope)
    var _self = this

    if ($scope.settings.porg_enabled) {
      // porg is enabled: must have at least one email address field filled
      if (!$scope.member.email && !$scope.member.email_porg1 && !$scope.member.email_porg2) {
        alert(_('members_fill_at_least_one_email'))
        $scope._sending = false
        return false
      }
    } else {
      // no porg: must have email address in primary field
      if (!$scope.member.email) {
        alert(_('members_cannot_delete_own_email'))
        $scope._sending = false
        return false
      }
    }

    // NB! DUPLICATE in updreqs.js
    if ($scope.passwordStrength) {
      if ($scope.passwordStrength.strength > 0) {
        if ($scope.member.newPassword_ === $scope.member.confirmNewPassword_) {
          $scope.member.password = $scope.member.newPassword_
        } else {
          alert(_('passwords_dont_match'))
          $scope._sending = false
          return false
        }
      } else {
        alert(_('insufficient_password_strength'))
        $scope._sending = false
        return false
      }
    }
    // else: passwordStrength is null - we are not setting/changing the password

    var updateMeParams = _get_edit_me_h_hash()
      ? {member: $scope.member, hash: _get_edit_me_h_hash()}
      : {member: $scope.member}

    update_me_api_func()(
      updateMeParams,
      // Success
      function () {
        _self.updreq_editme_form.$dirty = false
        location.href = thanks_goto()
      },
      // Fail
      a4.restErrorFactory($scope),
    )
  }

  $scope.cancel = function () {
    location.href = cancel_goto()
  }
}])

angular.module('updreqs').controller('UpdreqGetEditLinksCtrl', ['$scope', '$location', 'Updreq', 'Settings', function ($scope, $location, Updreq, Settings) {
  $scope.utils.setPageID('members')

  $scope.data = {}
  $scope.data.email = $location.search().email
  $scope._sending = false
  $scope.sent = false

  Settings.get({}, function (settings) {
    $scope.porg_enabled = settings.porg_enabled
    a4.loaded($scope)
  })

  $scope.send_edit_links = function () {
    if (!$scope.data.email) {
      alert(_('members_fill_email'))
      return false
    }
    $scope._sending = true
    Updreq.send_edit_links(
      {email: $scope.data.email},
      // Success
      function (a, b, c) {
        // alert('suksee, email: ' + $scope.data.email + JSON.stringify(a, b, c))
        $scope.sent = true
        $scope._sending = false
      },
      // Fail
      a4.restErrorFactory($scope),
    )
  }
}])
